import React from 'react'
import { Button } from 'antd'
import { useDispatch } from 'react-redux'
import $t from '../../../i18n'
import Actions from '../../../actions'
import RightIcon from '../../../resources/RightIcon.png'
import { clinicTypes, getClinicImage } from '../../../consts'

import './BotPreviewTemplate.css'

const BotPreviewTemplate = props => {
  const {
    contentTitle,
    contentPoints,
    actions,
    clinic = clinicTypes.MENTAL,
  } = props

  const dispatch = useDispatch()

  const onGoBack = () => {
    dispatch(Actions.createAction(Actions.REDIRECT_TO_SPECIALTY_SERVICES))
  }

  const renderHeader = () => {
    return (
      <div className="preview-header">
        <img
          className="go-back-icon"
          src={RightIcon}
          onClick={onGoBack}
          alt="go back"
        />
        {$t('pages.getStarted.mhBotPreviewDesktop.otherHealthServices')}
      </div>
    )
  }

  const renderBgImage = () => (
    <img
      className="image"
      src={getClinicImage(clinic).uri}
      alt={`${clinic} icon`}
    />
  )

  const renderButton = () => {
    return (
      <div className="template-buttons-container">
        {actions &&
          actions?.map((action, i) => (
            <Button
              type={action?.type || 'primary'}
              onClick={action?.handleOnClick}
              key={i}
              className="continue-button"
            >
              {action?.title}
            </Button>
          ))}
      </div>
    )
  }

  const renderContentPoints = () => {
    return contentPoints.map(eachPoint => {
      return (
        <div key={eachPoint} className="desc-pointer-container">
          <div className="point-marker"></div>
          <div>{eachPoint}</div>
        </div>
      )
    })
  }

  const renderContent = () => {
    return (
      <div className="content-container">
        <div className="title-container">
          {contentTitle}
          {renderBgImage()}
        </div>
        <div className="description">{renderContentPoints()}</div>
      </div>
    )
  }

  return (
    <div className="bot-preview">
      <div className="desktop-container">
        {renderHeader()}
        {renderContent()}
        {renderButton()}
      </div>
      <div className="mobile-container">
        {renderBgImage()}
        <div className="title">{contentTitle}</div>
        <div className="description">{renderContentPoints()}</div>
        {renderButton()}
      </div>
    </div>
  )
}

export default BotPreviewTemplate
